import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from "reactstrap";
import apiGlobal from '../../global/api.global';
import { useSelector } from 'react-redux';
import { RootState } from '../../';
import { errorToast, successToast } from '../../Components/Toasts';
import { errResponse } from 'GenericForms/Helper';

const LubeOilMaster = () => {
    const [lubeOils, setLubeOils] = useState<Array<any>>([]);
    const [vesselLubes] = useState<Array<any>>([]);
    const { VesselID } = useSelector((state: RootState) => state.Reporting);

    useEffect(() => {
        const loadLubeOilOptions = async () => {
            await apiGlobal(`/lube_oil_list_master/`)
                .then((response) => {
                    setLubeOils(response.data);
                    return response.data;
                })
        }; loadLubeOilOptions();
    }, []);

    const handleLubeOilCheckbox = (e: any, lubeName: any, lubeId: number) => {
        if (e.target.checked === true) {
            vesselLubes.splice(parseInt(e.target.id), 0, {
                vessel_lube_oil_name: lubeName, lube_oil_name: lubeId, vessel_name: VesselID
            });
        } else {
            vesselLubes.splice(parseInt(e.target.id), 1);
        }
    }

    const VesselLubeOilSubmit = (e: any) => {
        apiGlobal.post(`/vessel_lube_oil_list/`, vesselLubes).then(res => {
            successToast("Data saved successfully!");
        }).catch(err => {
            if (errResponse.includes(err.response.status)) {
                errorToast("Internal error occured, please contact the admin");
            }
        });
    }

    return (
        <>
            <Row>
                <Col>
                    <div className="table-responsive mb-5">
                        <table className="table">
                            <thead className="table-light">
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Lube oil</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lubeOils &&
                                    lubeOils.map((lubeOil: any, index: number) => {
                                        return (
                                            <tr key={lubeOil.id}>
                                                <td>{index + 1}</td>
                                                <td>{lubeOil.lube_oil_name}</td>
                                                <td>
                                                    <div className="form-check mb-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`${index}`}
                                                            onChange={(e: any) => handleLubeOilCheckbox(e, lubeOil.lube_oil_name, lubeOil.id)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                        <Button type="button" color='primary' className='pos-end' onClick={VesselLubeOilSubmit}>Save</Button>
                    </div>
                </Col>
            </Row>
        </>
    )
};

export default LubeOilMaster;
